import { useQuery } from '@tanstack/react-query';

import { api } from './client';
import { queryKeys } from './queryKeys';

export interface UsageData {
  contacts: { count: number; limit: number | null };
  messages: { count: number; limit: number | null };
}

export function useUsage(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.usage.current(),
    queryFn: () => api.get<UsageData>('/usage'),
    staleTime: 1000 * 60 * 5, // 5 min - usage doesn't change that quickly
    enabled: opts?.enabled ?? true,
  });
}
